import { Dispatch, useEffect, useState } from "react"

import AIPlanner from "./Booking/AIPlanner"
import AIPlannerMobile from "./Booking/mobile/AIPlanner"
import Holiday from "./Booking/Holiday"
import HolidayMobile from "./Booking/mobile/Holiday"

import {
  homelogo,
  bizconnect,
  bizbooking,
  login,
  hash,
  yjsh,
  explore,
  spiral,
  aiplanner,
  aiplannerred,
  holidaypackage,
  holidaypackagered,
  help_white,
  testusermob,
  hamburger,
  ai,
  down,
} from "../../../assets"
import { useNavigate } from "react-router-dom"

const Hero = ({
  isLoggedIn,
  setLoginPopup,
}: {
  isLoggedIn: boolean
  setLoginPopup: Dispatch<boolean>
}) => {
  const navigate = useNavigate()

  const [userData, setUserData] = useState<{
    firstName: string
    lastName: string
    id: string
    email: string
    profile: string
  }>({
    firstName: "Shubh",
    lastName: "Mangukiya",
    id: "asdfasfa",
    email: "shubh_placeaa@gmail.com",
    profile: testusermob,
  })

  const [activeBooking, setActiveBooking] = useState("PLAN TRIP USING AI")
  const [showMore, setShowMore] = useState<boolean>(false)

  const navContents = [
    {
      logo: bizconnect,
      title: "BizConnect",
      desc: "Connect Your Business",
      route: "/biz-connect",
    },
    {
      logo: bizbooking,
      title: "BizBooking",
      desc: "Booking For Business",
      route: "/biz-booking",
    },
    {
      logo: login,
      route: "",
      title: isLoggedIn
        ? `Hi, ${userData?.firstName}`
        : "Login or Create Account",
    },
  ]

  const bookingContents = [
    {
      logoOn: aiplannerred,
      logoOff: aiplanner,
      title: "PLAN TRIP USING AI",
      component: <AIPlanner />,
      mobile: <AIPlannerMobile />,
    },
    {
      logoOn: holidaypackagered,
      logoOff: holidaypackage,
      title: "HOLIDAY PACKAGE",
      component: <Holiday />,
      mobile: <HolidayMobile />,
    },
  ]

  const handleNavbarClick = (title: string, route: string) => {
    title === "Login or Create Account"
      ? setLoginPopup(true)
      : title?.startsWith("Hi,")
      ? setShowMore(!showMore)
      : navigate(route)
  }

  const getInitials = (name: string) => {
    const nameArray = name?.split(" ")
    if (nameArray?.length > 1) {
      return (
        nameArray[0]?.slice(0, 1) +
        nameArray[nameArray?.length - 1]?.slice(0, 1)
      )
    } else {
      return nameArray[0]?.slice(0, 1)
    }
  }

  const moreOptionsContents = [
    {
      title: "My Profile",
      desc: "Manage your profile, traveller details, login details",
      image: login,
      route: "/profile",
    },
    {
      title: "My Booking",
      desc: "View booking details, Modify Bookings, Check booking status",
      image: bizconnect,
      route: "/bookings",
    },
    {
      title: "Help & Support",
      desc: "Get help, Submit your question, See frequently asked questions",
      image: help_white,
      route: "/help",
    },
  ]

  useEffect(() => {
    const handleScroll = () => {
      setShowMore(false)
    }
    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  const MoreOptions = () => (
    <div
      className="rounded-[15px] absolute lg:top-[60px] xl:top-[70px] 2xl:top-[80px] z-[5000] right-5 lg:p-[12px] xl:p-[14px] 2xl:p-[18px] flex flex-col lg:gap-[12px] xl:gap-[14px] bg-white text-black"
      style={{
        width: "max-content",
        boxShadow:
          "0px -1px 5px 0px rgba(0, 0, 0, 0.25), 0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
      }}
    >
      {moreOptionsContents?.map((moc) => (
        <div
          className="flex lg:px-[9px] cursor-pointer lg:gap-[12px] xl:gap-[16px] 2xl:gap-[22px] items-center"
          key={moc?.title}
          onClick={() => {
            setShowMore(false)
            navigate(moc?.route)
          }}
        >
          <div className="bg-black rounded-full lg:h-[30px] lg:w-[30px] xl:h-[35px] 2xl:h-[45px] 2xl:w-[45px] flex items-center justify-center xl:w-[35px]">
            <img
              className="xl:h-[18px] xl:w-[18px] lg:h-[14px] lg:w-[14px] 2xl:h-[23px] 2xl:w-[23px]"
              src={moc?.image}
              alt="more i"
            />
          </div>
          <div>
            <p className="whitespace-nowrap font-[600] lg:text-[16px] 2xl:text-[20px]">
              {moc?.title}
            </p>
            <p className="lg:w-[190px] xl:w-[200px] 2xl:w-[220px] lg:text-[10px] 2xl:text-[15px] font-[400] leading-[12px] 2xl:leading-[17px]">
              {moc?.desc}
            </p>
          </div>
        </div>
      ))}
    </div>
  )

  return (
    <div className="hidden lg:block h-screen bg-home-page-image bg-cover bg-center lg:px-[30px] xl:px-[40px] 2xl:px-[50px]">
      {/* Navbar */}
      <nav className="flex items-center justify-between lg:pt-[20px] xl:pt-[25px] 2xl:pt-[30px]">
        <img
          src={homelogo}
          alt="logo"
          className="lg:h-[35px] xl:h-[38px] 2xl:h-[45px]"
        />
        <div className="text-[#fff] font-[600] flex items-center lg:gap-[15px] xl:gap-[22px]">
          {navContents?.map((nc: any) => (
            <div
              key={nc?.title}
              className="flex cursor-pointer items-center lg:gap-[8px] xl:gap-[10px]"
              onClick={() => handleNavbarClick(nc?.title, nc?.route)}
            >
              <div className="xl:h-[32px] xl:w-[32px] lg:h-[28px] lg:w-[28px] 2xl:h-[38px] 2xl:w-[38px] flex items-center justify-center rounded-full bg-black">
                {nc?.title?.startsWith("Hi,") ? (
                  <div className="text-white font-[600] lg:text-[12px] 2xl:text-[15px] lg:translate-y-[1px] xl:text-[13px]">
                    {getInitials(
                      `${userData?.firstName} ${userData?.lastName}`
                    )}
                  </div>
                ) : (
                  <img
                    className="xl:h-[14px] xl:w-[14px] lg:w-[13px] lg:h-[13px] 2xl:h-[18px] 2xl:w-[18px]"
                    src={nc?.logo}
                    alt={nc?.title}
                  />
                )}
              </div>
              <div className="flex flex-col">
                <span className="lg:text-[14px] xl:text-[15px] 2xl:text-[18px]">
                  {nc?.title}
                </span>
                <span className="text-[#B9B9B9] lg:-mt-1 lg:text-[11px] xl:text-[12px] 2xl:text-[15px]">
                  {nc?.desc}
                </span>
              </div>
              {showMore && nc?.title?.startsWith("Hi,") && <MoreOptions />}
            </div>
          ))}
        </div>
      </nav>

      {/* Tag */}
      <div className="text-center lg:mt-[120px] 2xl:mt-[200px]">
        <p className="text-white lg:text-[22px] xl:text-[24px] 2xl:text-[28px] font-inter font-[600]">
          LET US PLAN YOUR PERFECT GATEWAY
        </p>
        <p className="text-[rgba(255,255,255,0.62)] font-lato lg:text-[18px] lg:-mt-1 2xl:text-[20px] font-[400] 2xl:font-[500]">
          Discover new destinations and plan your dream vacation with our
          user-friendly travel website.
        </p>
      </div>

      {/* Booking Toggle */}
      <div className="bg-white flex justify-around lg:py-2 rounded-full lg:mt-[28px] lg:mx-[22px] 2xl:mt-[40px] 2xl:mx-[28px]">
        {bookingContents?.map((bc) => (
          <div
            key={bc?.title}
            onClick={() => setActiveBooking(bc?.title)}
            className="flex cursor-pointer items-center lg:gap-[7px] xl:gap-[12px]"
          >
            <img
              className="lg:w-[18px] lg:h-[18px] 2xl:h-[20px] 2xl:w-[20px]"
              src={activeBooking === bc?.title ? bc?.logoOn : bc?.logoOff}
              alt={bc?.title}
            />
            <p
              className={`font-[600] lg:text-[14px] xl:text-[16px] 2xl:text-[18px] ${
                activeBooking === bc?.title ? "text-[#AB0101]" : "text-black"
              }`}
            >
              {bc?.title}
            </p>
          </div>
        ))}
      </div>

      {/* Booking Component */}
      <div className="lg:mt-[15px]">
        {bookingContents?.map(
          (bc, index: number) =>
            bc?.title === activeBooking && (
              <div key={index}>{bc?.component}</div>
            )
        )}
      </div>

      {/* Hashtag */}
      <div className="lg:ml-[18px] lg:mt-[15px] 2xl:mt-[25px] flex items-center justify-between">
        <div className="flex lg:gap-[9px] items-center">
          <img
            className="lg:w-[25px] lg:h-[50px] 2xl:w-[35px] 2xl:h-[60px]"
            src={hash}
            alt="hash"
          />
          <div className="text-white font-[600] 2xl:text-lg">
            <p>ExploreWithPLACEAA</p>
            <p className="lg:-mt-1">DiscoverWithPLACEAA</p>
          </div>
        </div>
        <div className="flex items-center">
          <img src={yjsh} className="lg:w-1/2" alt="yjsh" />
          <img
            className="lg:-translate-x-4 lg:translate-y-4 lg:scale-90"
            src={spiral}
            alt="spiral"
          />
        </div>
      </div>

      {/* Explore */}
      <div className="flex absolute bottom-[15px] left-0 right-0 justify-center items-center lg:gap-[9px]">
        <img
          className="lg:h-[12px] lg:w-[12px] 2xl:h-[15px] 2xl:w-[15px]"
          src={explore}
          alt="explore"
        />
        <p className="lg:text-[15px] 2xl:text-[20px] font-[600] text-white">
          EXPLORE
        </p>
        <img
          className="lg:h-[12px] lg:w-[12px] 2xl:h-[15px] 2xl:w-[15px]"
          src={explore}
          alt="explore"
        />
      </div>
    </div>
  )
}

export default Hero
